<template>
    <md-input v-model="valueSelf" type="text" @blur="count++" :key="count" ref="input" :maxlength="maxlength" @keypress="isNumber" v-bind="$attrs"/>
</template>

<script>
  export default {
    name: "NumberWings",
    props:['value', 'maxlength'],
    data(){return{
      count: 1
    }},
    computed:{
      valueSelf:{
        get(){return this.value},
        set(value){
          // value = value.replace(/[^\d]/g, '');
          this.$emit('input',value);
        },
      }
    },
    methods: {
      isNumber (val) {
        if (isNaN(Number(val.key))) {
          return val.preventDefault();
        }
      }
    },
  }
</script>
